/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Selected_CountInputs */



/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Selected_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const selected_count = /** @type {((inputs: Selected_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} sélectionné(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} ausgewählt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} selezionati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} выбрано`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} seleccionado`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 已选择`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} が選択されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} चयनित`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} selecionado`)
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
});